import React, { useEffect } from "react";
import TeamList from "../components/team/TeamList";
import ContactCTA from "../components/home/ContactCTA";

const TeamPage = () => {
  useEffect(() => {
    document.title = "Our Team | Professional Service Associates";
  }, []);

  return (
    <>
      <div className="bg-psa-green-600 py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white text-center font-display">
            Our Team
          </h1>
          <p className="text-psa-green-100 text-lg mt-4 max-w-3xl mx-auto text-center">
            Meet our dedicated professionals committed to providing exceptional
            tax and business consultancy services.
          </p>
        </div>
      </div>
      <TeamList />
      <ContactCTA />
    </>
  );
};

export default TeamPage;
